import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { userRegisterSuccess } from "../../redux/actions/auth";
import { BzButton } from "../../components";
import { Registration } from "../../containers/Login";
import { _registerationSuccessful } from '../../controllers';
import DoneOverlay from './DoneOverlay';
import { useNavigate } from 'react-router';
import { Container, Row, Col } from 'react-bootstrap';
import { getStatesAndCities } from '../../redux/actions/appInfo';
import { getAppInfoData, getUserLoggedIn, isGuestUser } from '../../utils/global_functions';
import { APP_INFO_PARAMS } from '../../utils/global_variables';
import config from '../../config.json'
const RegistrationModal = (props) => {

  const dispatch = useDispatch();


  const { registration, cityOptionData, arrStateOption, setCitySelected, setRegistration,
    handleChange, handleStateTypeahedChange, cityTypeaheadRef, statesCities,
    disabled, handleSubmit,  } = props;

  const userRegisterResp = useSelector(state => state?.auth?.userRegisterResp);
  const { appInfo } = useSelector(state => state.appInfo);
  const [bIsDone, setbIsDone] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if(appInfo?.length){
      config.Wave.Cloudfront_S3_URL = getAppInfoData(APP_INFO_PARAMS.APP_CDN_BASE_PATH);
      dispatch(getStatesAndCities());
    }else{

    }
  }, [appInfo,dispatch]);
  useEffect(() => {
    let objResp = _registerationSuccessful(userRegisterResp.message);


    if (objResp?.status) {
      setbIsDone(true);
      setTimeout(() => {
        // if (objResp?.data) {
        //    dispatch(handleModal([{ 'USER_LOG_OUT_CONFIRMATION_MODAL': true }]));
        // }
        // else { }
        setbIsDone(false);
        navigate(-1);
        dispatch(userRegisterSuccess({}));
        setRegistration({});
      }, 2000);
    }
  }, [userRegisterResp,dispatch]);

  const handleBack = () => {
    //Ameersha N - 20-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    const objLoginSession = getUserLoggedIn();    
    if (objLoginSession && isGuestUser()) {
      window?.close();
    } else {

      navigate(-1);
    }
    //Ameersha N - 20-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
  };

  return (
    <>
      {(userRegisterResp?.message === "Registration Successful") ?
        <DoneOverlay bIsDone={bIsDone}
          doneOverlayContent=
          {<div>
            <div className='font-regular font-size12 color-text'>Thank you for sharing your details!</div>
            <div className='font-regular font-size12 color-text'>Our representative will get back to you soon</div>
          </div>
          } />
        : null
      }
      <Container fluid className='p-0 custom-modal-overlay'> 
        <div className='logo-container ms-3'>    
          <div className='logo img-fluid'></div>      
          {/* <BzImageWithFallback className='logo img-fluid' src={`${config?.Wave?.Cloudfront_S3_URL}${config.TenantId}/images/logo.svg`} fallbackSrc={logo} alt="logo" /> */}
        </div>
        <div className='custom-modal-wrap'>
          <div className='custom-modal'>

            <Row className='g-0 p-5'>
              <Col md={1} className='d-flex justify-content-start align-self-start pt-1'>
                <div data-testid="back-button" className='icon-20 icon-backward-arrow icon-dark' onClick={handleBack}></div>
              </Col>
              <Col md={10} className='d-flex justify-content-start align-self-start'>
                <form className='w-100' autoComplete='off' onSubmit={handleSubmit}>
                  <Registration registration={registration} cityOptionData={cityOptionData} arrStateOption={arrStateOption} setCitySelected={setCitySelected} setRegistration={setRegistration}
                    handleChange={handleChange} handleStateTypeahedChange={handleStateTypeahedChange} cityTypeaheadRef={cityTypeaheadRef} statesCities={statesCities} />
                  {userRegisterResp.message !== 'Registration Successful' ? <div className='error-msg'>{userRegisterResp.message}</div> : null}
                  <Row className='g-0 mb-3 mt-5'>
                    <Col className='d-grid'>
                      <BzButton disabled={disabled} className={"btn btn-primary"} type={"submit"}>Submit</BzButton>
                    </Col>
                  </Row>
                </form>
              </Col>
              <Col md={1} className='d-flex justify-content-start align-self-start'>&nbsp;</Col>
            </Row>

          </div>
        </div>
      </Container>
    </>

  );
};

export default RegistrationModal;